var _path;
import * as React from "react";
var SvgPaginationPrev = function SvgPaginationPrev(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 4.3861439,4.6052 2.3949997,-2e-4 -2.3968837,2.3970833 10.6245961,0 v 1.9958334 l -10.6243961,0 L 6.7811436,11.394334 4.3861439,11.395 0.99114395,7.9996671 Z"
  }));
};
export default SvgPaginationPrev;